export default __webpack_public_path__ + "static/media/AmericanTouristerIvy.2b03c141.jpg";